import { UseAppFormProps } from "hooks/useAppForm";
import React, { useEffect, useMemo } from "react";
import { FormValueProps } from ".";
import useAppSelector from "hooks/useAppSelector";
import { apiUserOptions } from "apis";
import AppImage from "components/AppImage";
import AppEmpty from "components/AppEmpty";

interface Props {
    form: UseAppFormProps<FormValueProps>
}

export const PageSelectService: React.FC<Props> = ({ form }) => {
    const user = useAppSelector(state => state.user);
    useEffect(() => {
        apiUserOptions({});
    }, [])

    const users = useMemo(() => {
        return user.list.options.filter(item => item.specialty?.id === form.values.specialtyId);
    }, [user.list.options, form.values.specialtyId])
    return (
        <div className="p-4 bg-white rounded shadow">
            <h2 className="text-lg font-bold mb-4">CHỌN BÁC SĨ</h2>
            {
                users.length === 0 ?
                    <AppEmpty
                    // actionText="Tiếp tục"
                    // actionOnClick={() => {
                    //     form.handleChange({ userId: -1 })
                    // }}
                    /> :
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {users.map((u, i) => (
                            <div
                                key={i}
                                onClick={() => form.handleChange({ userId: u.id })}
                                className="border p-3 rounded cursor-pointer hover:border-blue-500 flex items-center gap-3"
                            >
                                <AppImage
                                    src={u.avatarUrl}
                                    alt="logo"
                                    className="w-12 h-12 object-cover rounded-full border"
                                />
                                <div>
                                    <p className="font-semibold">{u.firstName} {u.lastName}</p>
                                    <p className="text-gray-500">{u.specialty?.name}</p>
                                </div>
                            </div>
                        ))}
                    </div>}
            <div className="flex flex-col items-center justify-center py-5 text-center">
                <button
                    className="bg-blue-600 text-white px-10 py-2.5 rounded-full font-semibold hover:bg-blue-700 transition"
                    onClick={() => form.handleChange({ userId: -1 })}
                >
                    Tiếp tục
                </button>
            </div>
        </div>
    );
};
